module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_35.de96f0ea.png";